<template>
    <div class="columns">
        <div class="column is-7">
            <h1 class="is-size-1 has-text-weight-bold">{{title}}</h1>
            <p class="is-size-5">{{message}}</p>
        </div>
        <div class="column is-5 has-text-right">
            <img width="200" src="../assets/product_lassi.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
  name: "Success",
  props: {
    title: {
      type: String,
      default: "Success!"
    },
    message: {
      type: String,
      default:
        "Your Paytm Cash has been initiated and will be credited to the registered mobile number within 48 hrs."
    }
  }
};
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/routes/Success.vue